<template>
<div class="chapter">
<div class="inner_page">
<h1 class="calibre9 sgc-44">Illustrations</h1>
<p class="calibre1 dot1000"></p>
<p class="sgc-07">Mark V (male) tank used by the 301st Tank Battalion</p>
<p class="sgc-77">A M2A2 light tank crests a hill at speed</p>
<p class="sgc-77">Tanks of 3rd Battalion on maneuvers</p>
<p class="sgc-77">3rd Battalion formation of M2A2s and M2A3 light tanks</p>
<p class="sgc-77">Unit photograph of Company B, 66th Infantry</p>
<p class="sgc-77">A M2A3 and M2A4 of 3rd Battalion</p>
<p class="sgc-77">M2A3 light tank of 3rd Battalion</p>
<p class="sgc-77">M2 half-track of the 2nd Armored Division’s 78th Field Artillery</p>
<p class="sgc-77">Rail loading M2A3 of C Company</p>
<p class="sgc-77">M2A4 tanks of 1st and 2nd Battalions moving out</p>
<p class="sgc-77">Lt. Norris Perkins of Machine Gun Company</p>
<p class="sgc-77">Secretary of War Stinson’s visit to Fort Benning</p>
<p class="sgc-77">Lieutenant Perkins and Lieutenant McConnell of H Company</p>
<p class="sgc-77">Private Terrebone mans the .30 caliber machine gun on a M2A4 light tank</p>
<p class="sgc-77">Field repairs on a M2A4 in the forests of Fort Benning</p>
<p class="sgc-77">Inside view of the driver’s compartment of a M2A4 tank</p>
<p class="sgc-77">Inside view of the gun breech of a M2A4 light tank</p>
<p class="sgc-77">Student officers at the tank maintenance course at Fort Knox</p>
<p class="sgc-77">Recovering a M3 Stuart</p>
<p class="sgc-77">Formation of A Company</p>
<p class="sgc-77">3rd Battalion loaded aboard a train</p>
<p class="sgc-77">Men of the 66th getting some rest</p>
<p class="sgc-77">Sgt. Bill Rape and the crew of H-3</p>
<p class="sgc-77">M2A4 light tank of G Company</p>
<p class="sgc-77">1941 Dodge T202-VC1 command car</p>
<p class="sgc-77">Bringing down city hall</p>
<p class="sgc-77">Tankers of H Company cleaning their weapons</p>
<p class="sgc-77">M2A4s rail loading at Cowan, Tennessee</p>
<p class="sgc-77">New M2A4 light tank</p>
<p class="sgc-77">Lt. Joe Moore of H Company with his M2A4</p>
<p class="sgc-77">Half-track and jeep at the regimental headquarters</p>
<p class="sgc-77">Lt. Russell Bakey of H Company</p>
<p class="sgc-77">Tankers posing in their gas masks</p>
<p class="sgc-77">Refueling a M2A4</p>
<p class="sgc-77">M-3 Stuart of H Company</p>
<p class="sgc-77">M2A4 of F Company mired in forests of Louisiana</p>
<p class="sgc-77">Repairing a damaged bridge using logs</p>
<p class="sgc-77">A Company tanker removing tree branches from the suspension of his M-3 tank</p>
<p class="sgc-77">A marshy area has mired a M2A4</p>
<p class="sgc-77">H Company Stuart</p>
<p class="sgc-77">Motorcycle courier of H Company followed by tank column</p>
<p class="sgc-77">Train carrying the tanks of the 66th</p>
<p class="sgc-77">Company chow line operating out of a railroad car</p>
<p class="sgc-77">H Company Maintenance Section M2 half-track</p>
<p class="sgc-77">M2A4 light tank of the H Company commander</p>
<p class="sgc-77">Front cover of the 66th Armored Regiment’s Christmas Dinner</p>
<p class="sgc-77">New 28-ton M-3 Lee medium tank</p>
<p class="sgc-77">M-3 medium tank being recovered by a M-1 Ward La-France wrecker</p>
<p class="sgc-77">M-3s of H Company lined up in the field</p>
<p class="sgc-77">Dodge M-6 Gun Motor Carriage</p>
<p class="sgc-77">Officers planning meeting of H Company</p>
<p class="sgc-77">Early M4A1 Sherman tank</p>
<p class="sgc-77">Lieutenant Perkins of H Company</p>
<p class="sgc-77">M-3s of H Company crossing the Pee Dee River</p>
<p class="sgc-77">Lt. Ben Pate with M4A2 Sherman tank</p>
<p class="sgc-77">“Hawkeye” of H Company</p>
<p class="sgc-77">Company of Sherman tanks</p>
<p class="sgc-77">One of the unsung heroes, Sergeant Pruett</p>
<p class="sgc-77">Regimental chaplain Luke Bolin</p>
<p class="sgc-77">Capt. Norris Perkins of H Company</p>
<p class="sgc-77">The champion baseball team of H Company</p>
<p class="sgc-77">Sgt. Arden Gatzke</p>
<p class="sgc-77">Chaplain Luke Bolin going to visit soldiers in the hospital</p>
<p class="sgc-77">Regimental chaplain Luke Bolin at his typewriter</p>
<p class="sgc-77">Brig. Gen. John H. “Pee Wee” Collier</p>
<p class="sgc-77">Lt. James Burt of C Company and his cousin Zeke from B Company</p>
<p class="sgc-77">Field organ used by Chaplain Bolin in church services</p>
<p class="sgc-77">G.I. humor about a young Sicilian in front of a M-4 Sherman</p>
<p class="sgc-77">The mountainous terrain of Sicily</p>
<p class="sgc-77">Lieutenant Hartson and Lieutenant Roller of D Company</p>
<p class="sgc-77">Lt. William A. Nicholson, platoon leader in D Company</p>
<p class="sgc-77">Sicilian women waiting to draw water</p>
<p class="sgc-77">Streetside in Capaci</p>
<p class="sgc-77">The town of Partinico southwest of Palermo</p>
<p class="sgc-77">Lt. John Roller of D Company astride a burro</p>
<p class="sgc-77">Portrait of 2nd Lt. John Roller</p>
<p class="sgc-77">Maj. Herb Long</p>
<p class="sgc-77">The five officers of A Company</p>
<p class="sgc-77">English children giving the famous symbol of the Allies</p>
<p class="sgc-77">1st Lt. John Roller astride a Military Police WLA motorcycle</p>
<p class="sgc-77">Safety message</p>
<p class="sgc-77">Machine-gun training with the M1919A1 .30 caliber</p>
<p class="sgc-77">The great Joe Louis boxing for the soldiers</p>
<p class="sgc-77">Lt. John Roller displaying a 75mm Sherman tank round</p>
<p class="sgc-77">The famed “Brown Bomber,” Joe Louis</p>
<p class="sgc-77">Capt. Sten A. Bergstedt, commander of A Company</p>
<p class="sgc-77">English orphans trying out a Sherman tank</p>
<p class="sgc-77">Lt. John Roller posing with paratrooper at their link-up</p>
<p class="sgc-77">Knocked-out German Mark V Panther tank</p>
<p class="sgc-77">Sherman tank crew takes down their improvised shelter</p>
<p class="sgc-77">Shermans hidden under their camouflage nets</p>
<p class="sgc-77">Crewmen relaxing and writing letters beneath their lean-to and camouflage net</p>
<p class="sgc-77">Group of French resistance fighters armed with German Mauser 98K rifles</p>
<p class="sgc-77">Lt. Col. Lindsay C. Herkness, Jr.</p>
<p class="sgc-77">Lt. Col. Amzi “Rudy” Quillian, 3rd Battalion commander</p>
<p class="sgc-77">Tank company church service in France</p>
<p class="sgc-77">A rare treat for combat soldiers</p>
<p class="sgc-77">Three Dutch women with their hair cut for fraternizing with the Germans</p>
<p class="sgc-77">The welcome in Belgium</p>
<p class="sgc-77">Sherman tank of Company F approaches the Dutch-German border</p>
<p class="sgc-77">2nd Battalion men enjoy a <i>Life</i> Magazine during a lull in combat</p>
<p class="sgc-77">Capt. James M. Burt receiving the Medal of Honor from President Harry Truman</p>
<p class="sgc-77">Lt. John Roller beside his Sherman tank</p>
<p class="sgc-77">Capt. James M. Burt, Medal of Honor recipient</p>
<p class="sgc-77">Maj. Herb Long and Lt. Col. Hugh O’Farrell of 3rd Battalion</p>
<p class="sgc-77">The crew of F-15 “Fancy Pants”</p>
<p class="sgc-77">Changing tracks on Sherman tanks in the Ardennes</p>
<p class="sgc-77">75mm and 76mm gun Sherman tanks of the 66th</p>
<p class="sgc-77">Celeste Sasser at a USO Halloween party</p>
<p class="sgc-77">Lt. Lewis Sasser killed in action</p>
<p class="sgc-77">“Loretta II,” a 105mm Howitzer M-4E5 of 3rd Battalion</p>
<p class="sgc-77">A tank destroyer of 702nd Tank Destroyer Battalion and M-4 Shermans of H Company in position to attack</p>
<p class="sgc-77">Lt. Col. Hugh O’Farrell being awarded the Silver Star by General White</p>
<p class="sgc-77">Soldiers of Company F enjoy a break for chow and newspapers</p>
<p class="sgc-77">“Astoria,” a M-5 “Stuart” light tank of A Company</p>
<p class="sgc-77">The officers of A Company</p>
<p class="sgc-77">76mm gun Sherman tank of the 66th near Tuevan</p>
<p class="sgc-77">The Belgian Secretary of War and Brig. Gen. John Collier</p>
<p class="sgc-77">Brig. Gen. I. D. White being presented flowers by a young Belgian</p>
<p class="sgc-77">Engineers working to finish bridge over the Rhine</p>
<p class="sgc-77">T-26/M-26 “Pershing” heavy tank F-15 named “Fancy Pants”</p>
<p class="sgc-77">Capt. Cam Warren beside the sign pointing to the 3rd Battalion Headquarters</p>
<p class="sgc-77">Sherman tanks of Company H on the North German Plain</p>
<p class="sgc-77">Visit by Cardinal Spellman</p>
<p class="sgc-77">A grain sack of the German Waffen-SS</p>
<p class="sgc-77">German Ju-87 “Stuka” dive bomber captured intact on a German airfield</p>
<p class="sgc-77">The meeting of East and West</p>
<p class="sgc-77">The famous German 88mm gun in an antitank role</p>
<p class="sgc-77">The light tanks of A Company along a road in Grunewald</p>
<p class="sgc-77">M4 Shermans of the 66th lined up along the autobahn in the Grunewald</p>
<p class="sgc-77">Lt. Donald Critchfield relaxing in front of his pup tent</p>
<p class="sgc-77">Motorpool of A Company</p>
<p class="sgc-77">A M-26 “Pershing” heavy tank named “Hell on Wheels” beside a M-4 Sherman</p>
<p class="sgc-77">Capt. John Roller receiving his third Silver Star from Brig. Gen. John “Pee Wee” Collier</p>
<p class="sgc-77">The “All American” M-24 “Chaffee” light tank of A Company</p>
<p class="sgc-77">Capt. John Roller posed atop one of the German anti-aircraft guns</p>
<p class="sgc-77">M-5 “Stuart” and M-24 “Chaffee” light tanks of A Company</p>
<p class="sgc-77">American-made 2½-ton trucks of the Red Army</p>
<p class="sgc-77">Capt. Cam Warren receiving the Bronze Star</p>
<p class="sgc-77">Capt. Cam Warren next to his jeep in Berlin</p>
<p class="sgc-77">Crews lined up before their M-5 Stuart light tanks</p>
<p class="sgc-77">Lt. Donald Critchfield of F Company</p>
<p class="sgc-77">Sign of 2nd Battalion</p>
<p class="sgc-77">The ruined Reichstag</p>
<p class="sgc-77">Tankers of A Company in Potsdam</p>
<p class="sgc-77">Destroyed Soviet Josef Stalin-II heavy tank along a Berlin street</p>
<p class="sgc-77">Knocked-out German Mark V Panther tank with Berlin children</p>
<p class="sgc-77">Massive portrait of the “Big Three” allies erected in Berlin</p>
<p class="sgc-77">American soldiers and vehicles in front of the bombed-out Ministry of Propaganda</p>
<p class="sgc-77">Soviet soldier filming in Berlin with a crowd of German civilians</p>
<p class="sgc-77">Bombed-out buildings in Berlin</p>
<p class="sgc-77">Ruins of one of the large villas near the Grunewald</p>
<p class="sgc-77">Capt. John Roller in front of German He-111 bomber and Me-110 fighter bomber</p>
<p class="sgc-77">Three GIs sell a Russian a watch</p>
<p class="sgc-77">Soviet soldiers pose for a photo outside the battle-scarred ruin of the Reichschancellery</p>
<p class="sgc-77">Young German next to the dug-in turret of Mark IV tank</p>
<p class="sgc-77">The men of H Company pose in front of variety of their tanks</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ListofIllustrations.vue?09c96be8